import Main from './Main';

		console.log('test');
new Main();

